var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReligion = function SvgReligion(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34791_4073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94207 14.4558C5.26634 14.4558 3.83688 12.2095 3.42847 11.3927C4.65371 11.3927 6.49158 10.7801 7.1042 9.5548C4.65371 8.32956 4.65371 4.65383 5.26634 3.42859C7.1042 5.26646 9.55468 7.10432 10.1673 7.10432C10.7799 7.10432 12.6178 5.26646 14.4557 5.26646C15.926 5.26646 16.7019 7.10432 16.9062 7.71695C16.4978 7.71695 15.4359 7.34937 14.4557 8.32956C13.2304 9.5548 12.6178 14.4558 8.94207 14.4558Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14282 14.8571V17.7141",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.14282 17.7143H16.2857",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8571 14.8572H16.9999C16.6055 14.8572 16.2856 15.177 16.2856 15.5715V19.8572C16.2856 20.2516 16.6055 20.5715 16.9999 20.5715H19.8571C20.2515 20.5715 20.5714 20.2516 20.5714 19.8572V15.5715C20.5714 15.177 20.2515 14.8572 19.8571 14.8572Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2979 10.2757C16.2979 8.82481 16.9441 6.99445 18.8191 5.83374",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34791_4073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReligion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "religion.76476176ab0a37ed3cf1c5f3109a0515.svg";